/**
 * ★★ PC-7 — "Resultado por anúncio": por anúncio, leads → agendaram → compareceram → fecharam →
 * valor fechado, com as % do funil (pedido do dono, 24/out).
 *
 * ★ As linhas vêm de `analisar().porAnuncio`, que agrupa os MESMOS conjuntos do funil — a soma das
 * linhas é o funil. ★ A % vem com a FRAÇÃO ao lado ("26 de 78"): amostra pequena (1 de 1 = 100 %)
 * engana sem o denominador à vista. Denominador zero → "—". Acima de 100 % (fechou na janela quem
 * compareceu antes dela) → ">100%", como o funil faz, nunca o número cru.
 *
 * Barras: todas na MESMA régua (`maximo` = o maior número de leads), como as do painel de etapas.
 */

const pct = (v) => `${Number(v ?? 0).toFixed(0)}%`;
const moeda = (v) => Number(v ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });

/** "26 de 78 · 33%" — ou "—" quando não há denominador. */
function taxaComFracao(parte, todo) {
  if (!todo) return '—';
  const taxa = (parte / todo) * 100;
  return `${parte} de ${todo} · ${taxa > 100 ? '>100%' : pct(taxa)}`;
}

export default function ResultadoPorAnuncio({ linhas = [], maximo = 1 }) {
  if (!linhas.length) return <p className="em-breve">Nenhum lead no período.</p>;
  return (
    <div className="tabela-envolve">
      <table className="tabela tabela-anuncios">
        <thead>
          <tr>
            <th>Anúncio</th>
            <th>Leads</th>
            <th>Agendaram</th>
            <th>Compareceram</th>
            <th>Fecharam</th>
            <th>Valor fechado</th>
          </tr>
        </thead>
        <tbody>
          {linhas.map((l) => (
            <tr key={l.chave} data-anuncio={l.chave}>
              <td>{l.chave}</td>
              <td>
                <span className="barra-anuncio" aria-hidden="true">
                  <span style={{ width: `${Math.round((100 * l.leads) / Math.max(1, maximo))}%` }} />
                </span>
                <span className="num">{l.leads}</span>
              </td>
              <td className="num">{taxaComFracao(l.agendados, l.leads)}</td>
              <td className="num">{taxaComFracao(l.comparecimentos, l.agendados)}</td>
              <td className="num">{taxaComFracao(l.fechamentos, l.comparecimentos)}</td>
              <td className="num">{moeda(l.valor)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
